import React from 'react'

export const Instructions = ({id,instructions,hide}) => {
  return (
    <>
      <button className="dinfos-intv-instr__open btn dinfos-btn" type="button" aria-expanded={!hide} aria-controls={`#${id}`} data-open-instr aria-label="Instructions"><i className="fas fa-info"></i></button>
      <div className={`dinfos-intv-instr ${hide ? 'd-none' : ''}`} id={`${id}`}>
        <div className="dinfos-intv-instr__box">
          <div className="dinfos-intv-instr__icon dinfos-gold-icon dinfos-gold-icon--interactive"></div>
          <div className="dinfos-intv-instr__text">{instructions}</div>
          <button className="dinfos-intv-instr__close btn dinfos-btn dinfos-btn--primary" type="button" data-close-instr>Ok</button>
        </div>
      </div>
    </>
  )
}